import { Button, Col, message, Row, Segmented, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful from "../../restful";

interface DataType {
    status: string,
    method: string,
    time: string,
    url: string,
    body: string,
    query: string,
    _id: string,
    createdAt: string,
    updatedAt: string
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string, type: string | number }

const ErrorLogsTable: FC = () => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [type, setType] = useState<string | number>('app')
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const columns: ColumnsType<DataType> = [
        {
            sorter: true, title: 'اطلاعات', ellipsis: true, dataIndex: 'data', key: 'data',
            render(val: string) {
                return <div style={{ direction: "ltr", textAlign: "left" }}>{JSON.stringify(val) }</div>
            },
        },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'زمان ایجاد', dataIndex: 'createdAt', key: 'createdAt', width: 180,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/error-logs/paginate`, { params })
            .then((res) => {
                const result = res.data.result
                setItems(result.errorLogs);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.errorLogsCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({
            sortDir: "desc", sort: "createdAt", type,
            page: pagination.current, perPage: pagination.pageSize
        });
    }, [type])

    function resetData() {
        fetchData({
            sortDir: "desc", sort: "createdAt", type,
            page: pagination.current, perPage: pagination.pageSize
        });
    }
    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current, type,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "createdAt"
        });
    };

    return <>
        <Row gutter={[16, 16]} style={{ padding: "16px 0" }}>
            <Col flex="auto" >
                <Segmented options={['server', 'app', "other"]} value={type} onChange={setType} />
            </Col>
            <Col flex="none"><Button onClick={() => resetData()} >تازه سازی</Button></Col>
        </Row>

        <Table
            columns={columns}
            dataSource={items}
            loading={isLoaded}
            rowKey="_id"
            pagination={pagination}
            onChange={handleTableChange}
        />
    </>
}

export default ErrorLogsTable


